import { FC, useState } from "react";
import { Form, InputGroup, Tab, Tabs } from "react-bootstrap";
import "react-quill/dist/quill.snow.css";
import { Summary } from "./Summary";
import { getSampleData } from "./Util";
import { SeoOptimisationTabContent } from "./SeoOptimisationTabContent";
import {
  IoMdBulb,
  IoMdHelpCircle,
  IoMdSearch,
  IoMdTrophy,
} from "react-icons/io";
import { SeoGraderModel } from "../types";
import { AiToolsTab } from "./AIToolsTab";
// import { FaqsTabGenerator } from "./FaqsTabGenerator";
import SerpsTab from "./SerpsTab";
import { FaqsTabGenerator } from "./FaqsTabGenerator";

type Props = {
  seoGrader: SeoGraderModel;
  setSeoGrader: React.Dispatch<React.SetStateAction<SeoGraderModel>>;
  additionalKeyword: string;
  setAdditionalKeyword: React.Dispatch<React.SetStateAction<string>>;
  averageScore: number;
  wordCount: number;
  headingCount: number;
  linkCount: number;
  termCount: number;
  leftSectionRef: any;
  content: string;
};

const data = getSampleData();

export const RightSection: FC<Props> = ({
  seoGrader,
  setSeoGrader,
  averageScore,
  wordCount,
  headingCount,
  linkCount,
  termCount,
  additionalKeyword,
  setAdditionalKeyword,
  leftSectionRef,
  content,
}) => {
  const [seoTipsResult, setSeoTipsResult] = useState(data);
  const [activeKeys, setActiveKeys] = useState<string[]>([]);

  const toggleSection = (sectionKey: string) => {
    setActiveKeys((prev) =>
      prev.includes(sectionKey)
        ? prev.filter((key) => key !== sectionKey)
        : [...prev, sectionKey]
    );
  };

  const handleFocusKeywordChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSeoGrader((prev) => ({
      ...prev,
      focusKeyword: e.target.value, // Store the focus keyword in state
    }));
  };

  return (
    <div
      style={{
        height: "46rem",
        overflowY: "auto",
        boxShadow:
          "rgba(0, 0, 0, 0.05) 0px 6px 24px 0px, rgba(0, 0, 0, 0.08) 0px 0px 0px 1px",
        borderRadius: "8px",
        padding: "16px",
        backgroundColor: "white",
      }}
    >
      <Summary averageScore={averageScore} />

      {/* Add the metrics table here */}
      <div
        style={{
          margin: "0px 0 15px 0 ",
          padding: "4px",
          border: "1px solid #e0e0e0",
          borderRadius: "8px",
          backgroundColor: "#f9f9f980",
        }}
      >
        <table style={{ width: "100%", borderCollapse: "collapse" }}>
          <thead>
            <tr style={{ borderBottom: "1px solid #e0e0e0" }}>
              <th style={{ padding: "8px", textAlign: "left" }}>Words</th>
              <th style={{ padding: "8px", textAlign: "left" }}>Headings</th>
              <th style={{ padding: "8px", textAlign: "left" }}>Links</th>
              <th style={{ padding: "8px", textAlign: "left" }}>Terms</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td style={{ padding: "8px" }}>
                <span style={{ color: wordCount >= 300 ? "green" : "red" }}>
                  {wordCount}
                  {wordCount >= 300 ? "↑" : "↓"}
                </span>
              </td>
              <td style={{ padding: "8px" }}>
                <span style={{ color: headingCount >= 1 ? "green" : "red" }}>
                  {headingCount}
                  {headingCount >= 1 ? "↑" : "↓"}
                </span>
              </td>
              <td style={{ padding: "8px" }}>
                <span style={{ color: linkCount >= 1 ? "green" : "red" }}>
                  {linkCount}
                  {linkCount >= 1 ? "↑" : "↓"}
                </span>
              </td>
              <td style={{ padding: "8px" }}>
                <span style={{ color: termCount >= 1 ? "green" : "red" }}>
                  {termCount}
                  {termCount >= 1 ? "↑" : "↓"}
                </span>
              </td>
            </tr>
            <tr>
              <td style={{ padding: "8px" }}>300 (min)</td>
              <td style={{ padding: "8px" }}>1 (rec)</td>
              <td style={{ padding: "8px" }}>1 (min)</td>
              <td style={{ padding: "8px" }}>1 (min)</td>
            </tr>
          </tbody>
        </table>
      </div>

      <Form.Group className="mb-3" controlId="formTitleAndKeywords">
        <div className="row">
          <div className="col-md-6">
            {/* <InputGroup>
              <InputGroup.Text className="bg-light fw-bold">1</InputGroup.Text> */}
            <Form.Control
              type="text"
              placeholder="Enter focus keyword"
              value={seoGrader.focusKeyword}
              onChange={(e) =>
                setSeoGrader((prev) => ({
                  ...prev,
                  focusKeyword: e.target.value,
                }))
              }
              style={{ backgroundColor: "#FAFAFA" }}
            />
            {/* </InputGroup> */}
          </div>
          <div className="col-md-6">
            {/* <InputGroup>
              <InputGroup.Text className="bg-light fw-bold">2</InputGroup.Text> */}
            <Form.Control
              type="text"
              placeholder="Additional keyword"
              value={additionalKeyword}
              onChange={(e) => setAdditionalKeyword(e.target.value)}
              style={{ backgroundColor: "#FAFAFA" }}
              className="responsive768"
            />
            {/* </InputGroup> */}
          </div>
        </div>
      </Form.Group>

      <Form.Group className="mb-3" controlId="formMetaDescription">
        {/* <InputGroup>
          <InputGroup.Text className="bg-light fw-bold">3</InputGroup.Text> */}
        <Form.Control
          as="textarea"
          rows={2}
          placeholder="Enter a Meta description"
          value={seoGrader.metaDescription || ""} // Add value prop
          onChange={(e) =>
            setSeoGrader((prev) => ({
              ...prev,
              metaDescription: e.target.value,
            }))
          }
          style={{ backgroundColor: "#FAFAFA" }}
        />
        {/* </InputGroup> */}
      </Form.Group>

      <div className="mt-4">
        <Tabs
          defaultActiveKey="seo_optimization"
          id="responsive-tab-example"
          className="mb-3 custom_tabs"
          fill
        >
          <Tab
            eventKey="seo_optimization"
            title={
              <span style={{ display: "flex", alignItems: "center" }}>
                <IoMdSearch style={{ marginRight: "8px" }} />
                SEO Tips
              </span>
            }
          >
            <SeoOptimisationTabContent
              seoOptimization={seoGrader.tabs.seoOptimization}
              content={seoGrader.content}
              metaDescription={seoGrader.metaDescription}
            />
          </Tab>

          <Tab
            eventKey="ai-tools"
            title={
              <span style={{ display: "flex", alignItems: "center" }}>
                <IoMdBulb style={{ marginRight: "8px" }} />
                Google View
              </span>
            }
          >
            <AiToolsTab
              leftSectionRef={leftSectionRef}
              content={seoGrader.content}
              metaDescription={seoGrader.metaDescription}
            />
          </Tab>

          <Tab
            eventKey="top_10"
            title={
              <span style={{ display: "flex", alignItems: "center" }}>
                <IoMdTrophy style={{ marginRight: "8px" }} />
                SERPs
              </span>
            }
          >
            <SerpsTab query={seoGrader.focusKeyword} />
          </Tab>
          {/* <Tab
            eventKey="FAQ"
            title={
              <span style={{ display: "flex", alignItems: "center" }}>
                <IoMdHelpCircle style={{ marginRight: "8px" }} />
                FAQs
              </span>
            }
          > */}
          {/* <FaqsTabGenerator
              focusKeyword={seoGrader.focusKeyword}
              title={leftSectionRef.current?.getEditor()?.getText() || ""} // Get title from left section
              metaDescription={seoGrader.metaDescription}
              content={leftSectionRef.current?.getHTMLContent() || ""}
            /> */}
          {/* </Tab> */}
          <Tab
            eventKey="FAQ"
            title={
              <span style={{ display: "flex", alignItems: "center" }}>
                <IoMdHelpCircle style={{ marginRight: "8px" }} />
                FAQs
              </span>
            }
          >
            <FaqsTabGenerator
              focusKeyword={seoGrader.focusKeyword || ""}
              title={leftSectionRef.current?.getEditor()?.getText() || ""}
              metaDescription={seoGrader.metaDescription || ""}
              content={leftSectionRef.current?.getHTMLContent() || ""}
            />
          </Tab>
        </Tabs>
      </div>
    </div>
  );
};
